import React from "react";
import styled from "styled-components";

//
import LinkChain from "../components/link-chain/LinkChain";

export default function PageTop({ title, linkList }) {
  return (
    <StyledPageTop>
      <LinkChain linkList={linkList} />
      <h1>{title}</h1>
    </StyledPageTop>
  );
}

const StyledPageTop = styled.section`
  border-top: 1px solid #1d4080;
  padding: 56px 0 68px;
  background-color: var(--dark-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  h1 {
    color: var(--white);
    text-align: center;
    font-size: var(--fs-page-title);
    font-style: normal;
    font-weight: var(--fw-semibold);
    line-height: var(--lh-title);
  }

  @media (max-width: 768px) {
    padding: 48px 16px 54px;
    gap: 14px;
  }
`;
